<template lang="pug">
    v-flex(xs12 :class="`${name}`")
        v-container(class="m-block-section-progress__container py-0")
            v-layout(wrap)
                v-flex(xs12 class="mt-3")
                    e-typography-heading-3
                        slot(name="title") {{section.title}}
                v-flex(xs12 class="mt-0 mb-4 m-block-section-progress__body")
                    e-progress-linear-primary(reactive
                                              height="25"
                                              class="ma-0"
                                              :indeterminate="false"
                                              :value="progress")
</template>

<script>
    let name = 'm-block-section-progress';
    export default {
        name: name,
        props: {
            name: {
                type: String,
                default: name
            },
            section: {
                type: Object
            },
            item: {
                type: Object
            },
            query: {
                type: Array,
                required: true
            }
        },
        created () {
            this.count(this.section);
            this.countPos(this.section, true);
        },
        mounted () {
            let foo = document.getElementsByClassName('v-progress-linear__bar');
            let node = document.createElement("SPAN");
            node.classList.add(`${this.name}__text`);
            let tmp = document.createTextNode(`${this.progress} %`);
            node.appendChild(tmp);
            foo[1].appendChild(node)
        },
        data: () => ({
            nodes: 0,
            nodesBefore: 0
        }),
        watch: {
            item: function () {
                this.countPos(this.section, true);
            },
            progress: function (n, p) {
                if(n !== p){
                    document.getElementsByClassName(`${this.name}__text`)[0].innerHTML = `${n} %`;
                }
            }
        },
        computed: {
            progress() {
                if(!this.nodesBefore) return this.nodesBefore;
                return Math.round(((this.nodesBefore / this.nodes) * 100));
            }
        },
        methods: {
            count(item) {
                ++this.nodes;
                if(!this.$lodash.isEmpty(item.children)){
                    item.children.forEach((v) => {
                        this.count(v)
                    });
                }
            },
            countPos(item, start) {
                if(start) this.nodesBefore = 0;

                 this.getPos(item, start)
            },

            getPos(item, start) {
                if(!start) {
                    if(item.type === this.item.type &&
                       item.id === this.item.id &&
                       item.progress === this.item.progress &&
                      item.title === this.item.title) {

                        return true;
                    }
                }

                ++this.nodesBefore;

                if(!this.$lodash.isEmpty(item.children)){
                    return item.children.some((v) => {
                        return this.getPos(v)
                    });
                }
            }
        }
    }
</script>

<style lang="scss">
    .m-block-section-progress {
        background-color: var(--v-secondary-base);

        &__body {
            padding: 0px 12px !important;
        }

        &__text {
            font-size: 0.9rem;
            color: var(--v-secondary-base);
            position: absolute !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%) !important;
        }

        &__container {
            display: block !important;
        }
    }
</style>
